import React from 'react';
import styled, { css } from 'styled-components';
import { minBp } from 'src/lib/theme';
import Button from 'components/Button/Button';

export const Wrap = styled.div`
  @media ${minBp('tabletLarge')} {
    display: flex;
    width: 900px;
    height: 500px;
    max-height: 500px;
  }

  @media ${minBp('desktop')} {
    width: 1000px;
  }
`;

export const Info = styled.div`
  padding: 36px 30px 28px;

  @media ${minBp('tabletLarge')} {
    width: 50%;
    border-left: 1px solid rgba(167, 169, 172, 0.5);
    padding: 75px 60px 55px;
    overflow: auto;
  }

  svg {
    height: 14px;
    width: 25px;
    padding-left: 9px;
    padding-right: 5px;
  }
`;

export const Name = styled.h4`
  text-transform: uppercase;
  margin-bottom: 5px;
`;

export const PartNumberStyles = css`
  display: block;
  font-size: 13px;
  color: #000;
  margin-left: 5px;
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const PartNumberWrap = styled.div`
  ${PartNumberStyles}
  display: flex;
  margin-left: 0;
`;

export const PartNumber = styled.span`
  ${PartNumberStyles}
`;

export const Description = styled.div`
  font-size: 12px;
  line-height: 19px;
  margin-top: 8px;
  margin-bottom: 14px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    line-height: 24px;
    margin-top: 11px;
    margin-bottom: 20px;
  }

  * {
    font-size: inherit;
    line-height: inherit;
    color: inherit;

    &:before {
      color: inherit;
    }
  }

  ul {
    padding-left: 25px;
  }
`;

export const TotalWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const TotalStyles = css`
  color: black;
  font-size: 14px;
  line-height: 22px;
  padding-right: 9px;
  border-right: 1px solid #2a2a2a;

  @media ${minBp('desktop')} {
    font-size: 16px;
    line-height: normal;
  }

  ${({ hasFittingTime }) =>
    !hasFittingTime
      ? `
    border-right: none;
  `
      : ``}
`;

export const Price = styled.span`
  ${TotalStyles}
`;

export const Fitting = styled.span`
  ${TotalStyles}
  padding-right: 0;
  border-right: 0;
`;

export const FittingTime = styled.span`
  padding-right: 5px;
`;

export const Slide = styled.div`
  width: 100%;
  height: 100%;
  max-width: 150px;
  max-height: 150px;
  background-size: contain;
  background-position: center center;
  background-color: white;
  background-repeat: no-repeat;
  margin: auto;

  @media ${minBp('tabletLarge')} {
    max-width: 200px;
    max-height: 200px;
  }

  @media ${minBp('desktop')} {
    max-width: 250px;
    max-height: 250px;
  }
`;

export const PlaceholderImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;

  @media ${minBp('tabletLarge')} {
    width: 50%;
  }
`;

export const AddAccessoryButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.buttons.default};
  color: white;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 16px;
  padding: 0 30px;
  width: auto;
  height: 40px;
  line-height: 100%;
  margin: 20px 0px 0px;
  width: 100%;

  svg {
    height: 12px;
    margin-right: 5px;
    transform: scale(1.25);
  }

  @media ${minBp('tabletLarge')} {
    width: auto;
    min-width: 160px;
  }
`;
